export default __webpack_public_path__ + "static/media/zido_1.3d4eb08e.png";